module.exports = __webpack_public_path__ + "img/Business_item_3.e5ff8c06.jpg";